import './ExistingCommentAudioPlayer.css';

import * as React from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
// import AudioRecorder, { AudioRecorderUseMode, PlaybackState } from '../../../_components/AudioRecorder';
import { AudioRecorderUseMode } from '../../../_components/AudioRecorder/AbstractAudioView';
import { PlaybackState } from '../../../_components/AudioRecorder/AudioPlayer';
import { AudioRecorder } from '../../../_components/AudioRecorder/AudioRecorder';
import { colors } from '../../../styles/colors';
import { AddButton } from './AddButton';
import {
    existingCommentAudioRecorderStyle,
    existingCommentButtonContainerStyle,
    existingCommentProgressLabelStyle,
    existingCommentProgressTrackStyle,
    existingCommentStartStopButtonStyle,
    manageButtonContainerStyle,
    newCommentProgressBackgroundStyle,
    newCommentProgressBarStyle,
    newCommentProgressHandleStyle,
    placeholderTextStyle,
    progressHandleHiddenStyle
} from './AudioStyles';
import { ClearButton } from './ClearButton';
import { createPauseButton } from './PauseButton';
import { createStartButton } from './StartButton';
import { createStopButton } from './StopButton';

const StartButtonComponent = createStartButton(32);
const StopButtonComponent = createStopButton(32);
const PauseButtonComponent = createPauseButton(32);

interface IProps {
    startWithUri?: string;
    startWithUriLength?: number;
}

export const ExistingCommentAudioPlayer: React.SFC<IProps> = ({ startWithUri, startWithUriLength }) => (
    <div className="commentAudioPlayer">
        <AudioPlayer
            src={startWithUri}
            customAdditionalControls={[]}
            layout="horizontal-reverse"
            customVolumeControls={[]}
            showJumpControls={false}
            customProgressBarSection={
                [
                    RHAP_UI.PROGRESS_BAR,
                    RHAP_UI.CURRENT_TIME,
                ]
            }
        />
    </div>
);



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/ExistingCommentAudioPlayer.tsx